// Ачилт удирдлага (canvas Ord_Shipping): 3 tabs
//   Хуваарилагдсан - the pull sheet list
//   Зөрчилтэй ачаа - shortages per pull sheet (Ord_Picking)
//   Дууссан        - the same list forced to LOADED (warehouse keeper confirmed)

import { Tabs } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { PageLayout } from "../../components/layout";
import { usePermission } from "../../components/permission";
import { PickingShortage } from "../../components/picking-shortage";
import { SupplierShippingCustomerList } from "../../components/supplier-shipping-customer/list";

const DEFAULT_TAB = "ASSIGNED"

export function SupplierShippingTab() {
  const { t } = useTranslation(["delivery", "common"])
  const breadcrumbs = useBreadcrumb(t)
  const ORD_PS_LIST = usePermission("ORD_PS_LIST")
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get("tab") || DEFAULT_TAB

  const onTabChange = (v: string | null) => {
    const next = v ?? DEFAULT_TAB
    const params = new URLSearchParams(searchParams)
    params.set("tab", next)
    setSearchParams(params, { replace: true })
  }

  return (
    <PageLayout title={t("shipping.title")} breadcrumb={breadcrumbs}>
      {!ORD_PS_LIST.hasAccess ? ORD_PS_LIST.accessDenied() : (
        <Tabs value={activeTab} onChange={onTabChange} keepMounted={false}>
          <Tabs.List>
            <Tabs.Tab value="ASSIGNED">
              {t("shipping.tabs.assigned", { defaultValue: "Хуваарилагдсан" })}
            </Tabs.Tab>
            <Tabs.Tab value="SHORTAGE">
              {t("shipping.tabs.shortage", { defaultValue: "Зөрчилтэй ачаа" })}
            </Tabs.Tab>
            <Tabs.Tab value="COMPLETED">
              {t("shipping.tabs.completed", { defaultValue: "Дууссан" })}
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="ASSIGNED" mt="md">
            <SupplierShippingCustomerList />
          </Tabs.Panel>
          <Tabs.Panel value="SHORTAGE" mt="md">
            <PickingShortage />
          </Tabs.Panel>

          <Tabs.Panel value="COMPLETED" mt="md">
            <SupplierShippingCustomerList forcedStatus="LOADED" />
          </Tabs.Panel>
        </Tabs>
      )}
    </PageLayout>
  )
}

const useBreadcrumb = (t: (key: string) => string) => [
  {
    to: "/",
    label: t("common:breadcrumb.home"),
  },
  {
    label: t("shipping.breadcrumb"),
  },
]
